import { Injectable } from '@gitlab/needle';
import { CustomSlashCommandResolver } from '@gitlab-org/ai-context/node';
import {
  DynamicSlashCommandProvider,
  CUSTOM_COMMANDS_PROVIDER_PRIORITY,
  type DynamicSlashCommandsResult,
} from '../dynamic_slash_command_provider';
import { SlashCommandAction } from '../slash_command_handler';

@Injectable(DynamicSlashCommandProvider, [CustomSlashCommandResolver])
export class CustomSlashCommandProvider implements DynamicSlashCommandProvider {
  readonly priority = CUSTOM_COMMANDS_PROVIDER_PRIORITY;

  #resolver: CustomSlashCommandResolver;

  constructor(resolver: CustomSlashCommandResolver) {
    this.#resolver = resolver;
  }

  async getCommands(): Promise<DynamicSlashCommandsResult> {
    const { commands, warnings } = await this.#resolver.getCustomSlashCommands();

    return {
      commands: commands.map((command) => ({
        name: `/${command.name}`,
        description: command.description ?? `Custom command (${command.source})`,
        action: SlashCommandAction.CustomCommand,
      })),
      warnings: warnings.map(
        (warning) => `Skipped custom command file "${warning.path}": ${warning.reason}`,
      ),
    };
  }
}
